<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('support.support_createTicket_theme')}}:
								| {{ isTopicSet ? $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.topic) : '' }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
								| {{ settings.difficult.amountOfRows + ' x ' + settings.difficult.amountOfColumns }}
						br
						template(v-if='settings.selectedSubTopics.length')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}:
								template(v-for='subTopic in settings.selectedSubTopics')
										span
												| {{ ' ' +  $i18n.t('trainer.trainer_gameFormSettingValue_' + subTopic) }};
										br
				br
				slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        computed: {
            isTopicSet() {
                return !!this.settings.topic;
            },
        },
    };
</script>
